import Vue from 'vue'

/*
    @params val 要过滤的字符串,number长度限制 
*/
Vue.filter('limitWord',(val,number)=>{
    // val=val.toString();
    if(!val) return '';
    number=number||15;
    return val.length>number?val.substr(0,number)+'...':val;
});


/*
    @params format 示例 'Y-M-D h:m:s' 年月日，时分秒自由组合
*/
Vue.filter('timeFormater',(time,format)=>{
    format = format || 'Y-M-D';
    const add0=val=>val<10?'0'+val:val;
    let d=new Date(time);
    let Y=d.getFullYear();
    let M=add0(d.getMonth()+1);
    let D=add0(d.getDate());
    let h=add0(d.getHours());
    let m=add0(d.getMinutes());
    let s=add0(d.getSeconds());
    let tarr=[Y,M,D,h,m,s];
    ['Y','M','D','h','m','s'].map((n,i)=>{
      format=format.replace(n,tarr[i])
    });
    return format
});